module.exports = __webpack_public_path__ + "dashboard/img/up.80dddb8fe68d07f77879ee8df790949e.svg";